window.$ = require('jquery');
import ScrollReveal from 'scrollreveal';
/* import Rellax from 'rellax'; */
import Swiper from 'swiper';
import fancybox from '@fancyapps/fancybox';
import Masonry from "masonry-layout";
import plyr from "plyr";

$(document).ready(function () {

  ScrollReveal().reveal('.section', {
    beforeReveal: function (el) {
      $(el).addClass("activeAnim");
    }
  });

/*   if ($('.section-service .rellax').length > 0) {
    new Rellax('.section-service .rellax', {
      center: true
    });
  } */


  var activeHeader = function () {
    var winPos = $(window).scrollTop();
    if (winPos > 80) {
      $("header").addClass("header-active");
    } else {
      $("header").removeClass("header-active");
    }
  };
  activeHeader();
  $(window).scroll(function () {
    activeHeader();
  });

  $(".hamburger").click(function (event) {
    $(this).toggleClass("h-active");
    $("body").toggleClass("main-nav-active");
  });

  $(".main-nav .fl").on('click', function (event) {
    var $fl = $(this);
    $(this).parent().siblings().find('.submenu').slideUp();
    $(this).parent().siblings().find('.fl').addClass('plus').text("+");
    if ($fl.hasClass('plus')) {
      $fl.removeClass('plus').addClass('minus').text("-");
    } else {
      $fl.removeClass('minus').addClass('plus').text("+");
    }
    $fl.next(".submenu").slideToggle();
  });

  var heroslider = new Swiper('.heroSlide', {
    loop: true,
    effect: "fade",
    speed: 2000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    on: {
      init: function () {
      }
    }
  });

  var controller = new ScrollMagic.Controller();
  /* var controller = new ScrollMagic.Controller();
  var winH = $(window).height();
  var hrHeight = $(".section-service").innerHeight();
  if (winH > hrHeight) {
    var slides = ["#fixedTop"];

    var slideParallaxScene;
    slides.forEach(function (slide, index) {
      var $bcg = $(slide);
      var $bcgHeight = $bcg.height();
      slideParallaxScene = new ScrollMagic.Scene({
        triggerElement: "#fixedTop",
        triggerHook: 'onLeave',
        duration: $bcgHeight
      })
        .setPin(slide, { pushFollowers: false })
        .addTo(controller);

    });

  } */



  // $('.animfadeIn').not(".animCompleted").each(function () {
  //   $(this).css
  //   var animdur = $(this).data("animdur") || 1;
  //   var hook = $(this).data("hook") || 1;
  //   ScrollReveal().reveal($(this), {
  //     easing: "ease-in",
  //     distance: '15px',
  //     duration: 500,
  //     afterReveal: function (el) {
  //       $(el).addClass("animCompleted");
  //     }
  //   });
  // });
  console.log("compiled");
  $('.animfadeIn').not(".animCompleted").each(function () {
    $(this).addClass('animCompleted');
    var animdur = $(this).data("animdur") || 1;
    var hook = $(this).data("hook") || 0.8;
    var myScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: hook,
      reverse: false
    })
      .setTween(TweenMax.fromTo(this, animdur, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0 }))
      .addTo(controller);
  });


  if ($(".grid").length > 0){
    var msnry = new Masonry(".grid", {
      itemSelector: "li"
    });
  }

  const player = new plyr("#player");

  $(".gotop").hide();
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('.gotop').fadeIn();
      } else {
        $('.gotop').fadeOut();
      }
  });
    // scroll body to 0px on click
  $('.gotop').click(function () {
    $('body,html').animate({
        scrollTop: 0
      }, 800);
    });
  });


}); //document ready end
